<template>
  <div class="mainBox">
    <div class="panleBox">
      <div class="section van-hairline--top">
        <div class="maintitle value">{{form.monthTime}}考勤汇总</div>
        <!-- <div class="bannerFather">
          <div class="bannerDiv yellow">应出勤<br/>{{form.workDays}}天</div>
          <div class="bannerDiv blue">计薪<br/>{{form.regularDays}}天</div>
          <div class="bannerDiv red">全勤奖金<br/>{{form.everyPresent}}元</div>
        </div> -->
        <div class="head_box">
          <div class="mainbox">
            <div class="mainvalue">&nbsp;&nbsp;&nbsp;&nbsp;应出勤：{{form.workDays}}天</div>
            <div class="mainvalue" style="color: #FF1493;">&nbsp;&nbsp;&nbsp;&nbsp;应计薪：{{form.meterDays}}天</div>
            <div class="mainvalue" style="color: #FFD700">实际出勤：{{form.regularDays}}天</div>
          </div>
          <div class="right_tip" v-if="form.isManage == 1">
            <div v-if="form.everyPresent =='100'">全勤奖100元<img src="../../../assets/images/desktop/zan02.png" /></div>
            <div v-else>下个月加油哦<img src="../../../assets/images/desktop/sad.png" /></div>
          </div>
          <div class="conpany">福建云赢文化传媒有限公司</div>
        </div>
        <div class="details brs_bottom">
          <div class="lineNum"><span class="lineNum_flag"></span><span>考勤明细</span></div>
          <div style="padding:0px 6px 10px 6px;">
            <div class="flex-mb8 atu">
              <span class="key">部门</span>
              <span class="value">{{ form.deptName }}</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">姓名</span>
              <span class="value">{{ form.userName }}</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">月份</span>
              <span class="value">{{ form.monthTime }}</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">应出勤天数</span>
              <span class="value">{{ form.workDays || '--' }}</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">应计薪天数</span>
              <span class="value">{{ form.meterDays || '--' }}</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">实际出勤天数</span>
              <span class="value">{{ form.regularDays || '--' }}</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">入离职天数</span>
              <span class="value">{{ form.entryResignationDays || '--' }}</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">病假天数</span>
              <span class="value">{{ form.sickLeaveDays || '--' }}</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">事假天数</span>
              <span class="value">{{ form.matterLeaveDays || '--' }}</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">产假/产检天数</span>
              <span class="value">{{ form.maternityLeaveDays || '--' }}</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">调休</span>
              <span class="value">{{ form.exchangeDay || '--' }}</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">陪产假天数</span>
              <span class="value">{{ form.paternityLeaveDays || '--' }}</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">年假天数</span>
              <span class="value">{{ form.annualLeave || '--' }}</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">无薪假天数</span>
              <span class="value">{{ form.noSalaryDay || '--' }}</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">带薪假天数</span>
              <span class="value">{{ form.paidFamilyDays || '--' }}</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">旷工天数</span>
              <span class="value">{{ form.absenteeismDays || '--' }}</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">全勤奖金</span>
              <span class="value">{{ form.everyPresent || '--' }}</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">迟到/早退/缺卡次数</span>
              <span class="value">{{ form.lateDay || '--' }}</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">考勤成长金</span>
              <span class="value">{{ form.attendanceMoney || '--' }}</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">工牌成长金</span>
              <span class="value">{{ form.badgeMoney || '--' }}</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">培训成长金</span>
              <span class="value">{{ form.trainMoney || '--' }}</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">扣款合计</span>
              <span class="value">{{ form.allDeduct || '--' }}</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">审核状态</span>
              <span class="value">{{ formatHandel('checkStatus',form.checkStatus) }}</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">确认状态</span>
              <span class="value"><span v-if="form.isConfirm == '2'" style="color: #1989fa;">已确认</span><span v-else style="color: #ee0a24;">待确认</span></span>
            </div>
            <!-- <div class="flex-mb8 atu">
              <span class="key">本月天数</span>
              <span class="value">{{ form.monthDays }}天</span>
            </div> -->
            <!-- <div class="flex-mb8 atu">
              <span class="key">正常天数</span>
              <span class="value">{{ form.regularDays }}天</span>
            </div> -->
            <!-- <div class="flex-mb8 atu">
              <span class="key">事假天数</span>
              <span class="value">{{ form.matterLeaveDays }}天</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">早退次数</span>
              <span class="value">{{ form.earlyFrequency }}天</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">缺卡次数</span>
              <span class="value">{{ form.missingFrequency }}天</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">实际工作时长</span>
              <span class="value">{{ form.regularWorkSec }}小时</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">标准工作时长</span>
              <span class="value">{{ form.standardWorkSec }}小时</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">卫生成长金</span>
              <span class="value">{{ form.hygieneMoney }}元</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">会议成长金</span>
              <span class="value">{{ form.meetingMoney }}元</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">社保单位缴纳</span>
              <span class="value">{{ form.insuranceCompanyMoney }}元</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">社保个人缴纳</span>
              <span class="value">{{ form.insurancePersonalMoney }}元</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">公积金单位缴纳</span>
              <span class="value">{{ form.commonCompanyMoney }}元</span>
            </div>
            <div class="flex-mb8 atu">
              <span class="key">公积金个人缴纳</span>
              <span class="value">{{ form.commonPersonalMoney }}元</span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <p v-if="form.isConfirm=='1'" class="banner">
      <!-- style="margin-right:0.4rem" -->
      <van-button size="normal" type="info" @click="confirmHandle()" >
        &nbsp;&nbsp;确&nbsp;&nbsp;&nbsp;&nbsp;认&nbsp;&nbsp;
      </van-button>
      <!-- <van-button size="normal" type="info" plain hairline @click="confirmHandle(2)">{{callback?'再次反馈':'问题反馈'}}</van-button> -->
    </p>
    <p v-else class="banner">
      <van-icon name="checked" class="checkedIcon"/><span class="checkedIcon">已确认</span>
    </p>

    <!-- <van-dialog v-model="confirmVisible" title="考勤确认" width="95%" class="editVisit" :beforeClose="confirmBeforeClose" close-on-click-overlay show-cancel-button>
      <van-form ref="confirmForm" validate-trigger="onSubmit" class="formSty">
        <van-cell-group>
          <van-cell title="确认状态" class="label" required>
            <template>
              <van-tag size="large" type='primary' @click="confirmForm.status = '1'" color="#F4F5F7" text-color="#606060" :class="confirmForm.status == '1'?'tag-click':'tag-before'">正常</van-tag>
              <van-tag size="large" type='primary' @click="confirmForm.status = '2'" color="#F4F5F7" text-color="#606060" :class="confirmForm.status == '2'?'tag-click2':'tag-before'" style="margin-left: 10px">异常</van-tag>
            </template>
          </van-cell>
          <van-cell title="证明图片" class="label">
            <template>
              <van-uploader v-model="pictureList" :max-count="1" :after-read="uploadPictureFiles" :before-read="beforeRead" :before-delete="handleRemove" @oversize="onOversize" :max-size="10000 * 1024" />
            </template>
          </van-cell>
          <van-field v-model="confirmForm.remake"
            autosize
            label="备注"
            placeholder="请输入审核备注"
            type="textarea"
            show-word-limit/>
        </van-cell-group>
      </van-form>
    </van-dialog> -->
  </div>
</template>

<script>

import { List, Cell, Button, Tag, Dialog, Area, Toast, Icon, Field, Col, Row, CellGroup, Popup, Picker, Radio, RadioGroup, Grid, GridItem, Tab, Tabs, Form, Calendar } from 'vant'
// import { getSalaryDetailed, callback, mySalaryList, mySalarySelection, sendMessageCommon, callbackInfo } from '@/api/admi/salary'
// import { listUser } from '@/api/admi/user'
import { mapGetters } from 'vuex'
// import moment from 'moment'
import { listSummary, getSummary, updateSummary } from '@/api/admi/checkwork'

export default {
  computed: {
    ...mapGetters({
      userinfo: 'userinfo'
    })
  },
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Form.name]: Form,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Area.name]: Area,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Form.name]: Form,
    [Calendar.name]: Calendar
  },
  data() {
    return {
      picker: {
        visible: false,
        title: '',
        columns: []
      },
      salaryDetail: {
        claimStatus: '0'
      },
      showClonms: [],
      salaryDetailHeader: [],
      salaryDetailItems: [],
      moneyTotal: '',
      fkForm: {
        month: this.$route.query.month,
        nickName: this.$store.state.user.user.nickName,
        cbType: 1, // 1 确认 2 反馈 3 反馈回复 4 查看
        remark: ''
      },
      form: {},
      userId: this.$store.state.user.user.userId,
      showFkPop: false,
      dataVisible: false,
      over: false,
      callback: false,
      selectSalaryName: this.$route.query.month + '月薪资',
      monthOptions: [],
      balanceStatusOptions: {},
      claimStatusOptions: {},
      // 产品类型树选项
      businessTypeTreeOptions: this.$store.state.dictOptions.businessTypeTree || [],
      sendMessageDatas: {
        month: this.$route.query.month,
        title: this.$route.query.month + '工资问题反馈-' + this.$store.state.user.user.nickName,
        callbackId: '',
        toUser: '',
        nickName: this.$store.state.user.user.nickName,
        isCallback: '1', // 1反馈 0工资条
        remark: ''
      },
      callbackUserInfo: {
        remark: '反馈者的反馈信息',
        createTime: '2021-12-12 12:35:12'
      },
      confirmVisible: false,
      confirmForm: { status: '1' },
      options: {
        checkStatusOptions: []
      },
      pictureList: []
    }
  },
  mounted() {
    this.init()
    this.getDicts('kq_check_status').then(res => {
      this.options.checkStatusOptions = this.setDictToInt(res)
    })
  },
  methods: {
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    // clickTag(val) {
    //   this.confirmForm.status = val
    // },
    // 返回布尔值
    // beforeRead(file) {
    //   const imgArr = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp', 'image/svg+xml', 'image/vnd.adobe.photoshop']
    //   if (!imgArr.some((item) => { return file.type === item })) {
    //     Toast('请上传 图片 文件')
    //     return false
    //   }
    //   return true
    // },
    // onOversize(file) {
    //   console.log(file)
    //   Toast('图片大小不能超过 10mb')
    // },
    // handleRemove(file) {
    //   this.confirmForm.payImg = ''
    //   this.pictureList = []
    //   return true
    // },
    // async uploadPictureFiles(file) {
    //   const _file = file.file
    //   // 通过 FormData 对象上传文件
    //   var formData = new FormData()
    //   formData.append('file', _file)
    //   await payment.uploadContractFile(formData)
    //     .then((res) => {
    //       if (res.code === 200) {
    //         this.confirmForm.payImg = res.url
    //         this.pictureList = []
    //         this.pictureList.push({ url: res.url })
    //         Toast.success(res.msg)
    //       } else {
    //         Toast.fail(res.msg)
    //       }
    //     })
    //     .catch(function (error) {
    //       console.error(error)
    //     })
    // },
    // async confirmBeforeClose(type, done) {
    //   if (type === 'confirm') {
    //     try {
    //       await this.$refs.confirmForm.validate()
    //       await payment.addPayer(this.confirmForm)
    //         .then((res) => {
    //           Toast.success('确认成功')
    //           setTimeout(() => {
    //             this.confirmVisible = false
    //           }, 500)
    //         }).catch(() => {})
    //       done()
    //     } catch (err) {
    //       return done(false)
    //     }
    //     return done(false)
    //   } else {
    //     done()
    //     this.confirmVisible = false
    //   }
    // },
    init() {
      document.title = '我的考勤明细'
      const id = this.$route.query.id
      if (id) {
        getSummary(id).then((response) => {
          this.form = response.data || []
        })
      } else {
        const monthTime = this.$route.query.month || null
        const userId = this.userId

        listSummary({ monthTime: monthTime, userId: userId }).then((response) => {
          const data = response.rows || []
          this.form = data[0]
        })
      }
    },
    confirmHandle() {
      // this.confirmVisible = true
      Dialog.confirm({
        message: '是否确认考勤信息？'
      })
        .then(() => {
          this.form.isConfirm = 2
          this.form.isRead = 2
          updateSummary(this.form).then((response) => {
            Toast.success('已确认')
          })
        })
        .catch(() => {
        })
    },
    formatDate(date) { // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.head_box{
  height: 320px;
  margin: 0 auto;
  background-image: url(../../../assets/images/desktop/kqbj.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  position: relative;
  .mainbox{
    padding-top: 40px;
    .mainvalue{
      line-height: 60px;
      color: #f4f4f4;
      font-size: 32px;
      padding-left: 60px;
    }
  }
  .conpany{
    margin-top: 30px;
    padding-left: 100px;
    color: #f4f4f4;
    font-size: 36px;
  }
  .right_tip{
    position: absolute;
    right: 0;
    top: 40px;
    background-color: #ed6a0c;
    padding: 16px 20px;
    font-size: 28px;
    border-radius: 10px 0 0 10px;
    color: #f4f4f4;
    div{
      display: flex;
      align-items: center;
      img{
        width: 46px;
        margin-left: 20px;
      }
    }
  }
}
  .title{
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    margin: 30px 0 0 30px;
    span{
      font-size: 32px;
      margin-left: 5px;
    }

    .icon {
      display: inline-block;
      width: 40px;
      height: 40px;
    }
  }
  .selectBox{
    // margin-left:20%;
    display: flex;
    align-items: center;
    .select_button{
      width: 100%;
      height: 1.39rem;
      position: fixed;
      top: 0;
      z-index: 100;
      span,i{
        font-size: 0.55rem!important;
        font-weight: 400;
      }
    }
    span{
      font-size: 32px;
      margin-left: 5px;
    }
  }
  .panleTitle{
    margin-top: 30px;
    height: 60px;
    display: block;
    line-height: 65px;
    margin-left: 20px;
    font-size: 32px;
    text-align: left;
  }
  .mainBox{
    max-height: 17rem;
    overflow: auto;
    background-color: #fff;
  }

  .panleBox{
    width: 92%;
    font-size: 18px;
    margin:0 0 2.5rem 0.34667rem;
    background-color: #fff;
    .maintitle{
      font-size: 0.65rem;
      width: 100%;
      text-align: center;
      color: #333333;
      height: 1.15rem;
      line-height: 1.15rem;
      margin-bottom: 20px;
      border-bottom: 0.5px solid #b7b5b5;
    }
    .bannerFather{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 20px;
      .bannerDiv{
        width: 30%;
        height: 1.5rem;
        line-height: 0.75rem;
        font-size: 0.45rem;
        color: #fff;
        text-align: center;
        box-shadow: 0 0.26667rem 0.4rem -0.4rem #000;
        border-radius: 5px;
      }
      .yellow{
        background-color: #f9b506;
      }
      .blue{
        background-color: #2bc2d7;
      }
      .red{
        background-color: #5a79fb;
      }
    }
  }
  .banner{
    display: flex;
    margin-top: -0.26667rem;
    text-align: center;
    position: fixed;
    bottom: 0.4rem;
    background: #fff;
    width: 100%;
    justify-content: center;
    padding: 10px 0;
    padding-bottom: calc(20px + env(safe-area-inset-bottom));
  }
  .checkedIcon{
    color: #0c00b4;
    font-size: 0.45rem;
    margin-right: 0.1rem;
    line-height: 0.8rem;
  }
  .section {
    padding-top: 20px;
    font-size: 28px;
    color: #999;
    margin-left: 10px;
    margin-bottom: 20px;
    .details{
      background-color: #fff;
      margin-bottom: 100px;
      box-shadow: 0px 20px 30px -30px #000;
    }
    .atu{
      height: auto !important;
    }
    .atu:nth-last-of-type(1){
      border: none;
    }
  }
  .brs{
    border-radius: 0.3rem;
    border:1px solid #ccc;
    margin-bottom: 20px;
  }
  .brs_bottom{
    border-radius: 0.3rem;
    margin-bottom: 20px;
    padding-top: 20px;
  }
  .brs_box{
    background-image: url("../../../assets/images/tj/salaryBj.jpg");
    background-size: cover;
    box-shadow: 0px 20px 30px -30px #000;
  }
  .lineNum{
    line-height: 1rem;
    height: 1rem;
    margin-bottom: 0.3rem;
    font-size: 0.42rem;
    text-align: center;
    // background-color: #090097;
    border-top-left-radius: 0.13333rem;
    border-top-right-radius: 0.13333rem;
    .lineNum_flag{
      width: 0.18rem;
      display: block;
      height: 0.55rem;
      float: left;
      background-color: #094681;
      margin: 0.22rem;
      border-radius: 0.06rem;
    }
    span{
      color: #000;
      font-size: 0.42rem;
      text-align: left;
      display: block;
    }
  }
  .lineNum2{
    line-height: 1rem;
    height: 1rem;
    margin-bottom: 0.3rem;
    font-size: 0.40rem;
    text-align: center;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    span{
      color:#fff;margin-left:20px;
    }
  }
  .flex-mb8 {
    display: flex;
    margin-bottom: 10px;
    height: 60px;
    line-height: 60px;
    border-bottom: 1px dashed #ccc;
  }
  .flex-mb8-up {
    display: flex;
    margin-bottom: 30px;
    height: 60px;
    line-height: 60px;
  }
  .key{
    font-size: 0.38rem;
    color: #333;
    width: 50%;
    text-align: left;
  }
  .value{
    font-size: 0.38rem;
    color: #666;
    text-align: right;
    width: 50%;
  }
  .question_icon{
    width: 0.8rem;
    height: 0.8rem;
    border-radius: 0.5rem;
    background-color: #a7a3a3;
    position: fixed;
    right: 0;
    bottom: 10px;
    color: #fff;
  }
  .editVisit{
    min-height: 9rem;
    height: 50%;
    top: 46%;
    .formSty{
      height: 100%; overflow: scroll; margin: 10px 5px;
    }
  }
  .editVisit /deep/.van-dialog__content {
    height: 70%;
    .van-field--error .van-field__control{
      font-size: 0.38rem;
    }
    .van-field__control{font-size: 0.38rem;}
    .van-cell__value {
      min-width: 67%; // 可根据自己需求设定值
      text-align: left;
    }
    .tag-click{
      border: 0.02667rem solid #1E90FF !important;
      color:#fff !important;
      background-color: #1E90FF !important;
    }
    .tag-click2{
      border: 0.02667rem solid #ee0a24 !important;
      color:#fff !important;
      background-color: #ee0a24 !important;
    }
    .tag-before{
      border: 0.02667rem solid #999999 !important;
      background-color: #fff !important;
    }
  }
</style>
